type BrandLogoProps = {
  className?: string;
  /** Sadece yörünge ikonu (yazısız). Varsayılan: ikon + "oravity" yazısı. */
  iconOnly?: boolean;
};

/**
 * Gerçek yörünge ikonu — geometri Canva'daki ikon-yorunge.svg ile birebir,
 * değiştirilmedi. Renk currentColor ile temaya göre (light/cloud lacivert,
 * dark beyaz); turuncu nokta sabit.
 */
function OrbitIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 100 100" aria-hidden className={className}>
      <circle cx="50" cy="52" r="34" fill="none" stroke="currentColor" strokeWidth={12} />
      <circle cx="74" cy="28" r="10" fill="#F97316" />
    </svg>
  );
}

/**
 * Marka logosu = gerçek ikon + yanına yazılan "oravity" (ayrı HTML metin,
 * DOM'daki Poppins ile). Logonun görseli değiştirilmez; metin ayrı yazılır.
 */
export function BrandLogo({ className = "", iconOnly = false }: BrandLogoProps) {
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-2 text-[#172554] dark:text-white ${className}`}
    >
      <OrbitIcon className="block h-8 w-8 sm:h-9 sm:w-9" />
      {iconOnly ? null : (
        <span
          className="text-2xl font-medium leading-none tracking-tight sm:text-[1.65rem]"
          style={{ fontFamily: "var(--font-poppins), ui-sans-serif, sans-serif" }}
        >
          oravity
        </span>
      )}
    </span>
  );
}
